<template>
  <ValidationProvider ref="provider" mode="eager" :name="name" :rules="validationRules" v-slot="{ errors, passed }" slim>
    <div class="form-field" :class="{error: errors.length, 'valid': !warning && passed && value, 'disabled': disabled, 'loading': loading, 'warning': warning !== null && !errors.length }">
        <div class="label inline left middle" :class="{TA:isTestAchat}" v-if="label">
          <label v-if="label" class="title" :for="name">{{ label }}<span class="required" v-if="required">*</span></label>
          <span v-if="help" class="help" @click="showHelp = true">?</span>
        </div>
        <div class="status" :class="[{unit: unit !== null}, type, {TA:isTestAchat}]">
          <!-- Field Type -->
          <input v-if="type==='text'" class="input" type="text" :disabled="disabled" :placeholder="placeholder" :name="name" :id="name" v-bind:value="value" v-on:input="update($event.target.value)"/>
          <input v-if="type==='password'" class="input" type="password" :placeholder="placeholder" :name="name" :id="name" v-bind:value="value" v-on:input="update($event.target.value)"/>
          <input v-if="type==='email'" class="input" type="email" :placeholder="placeholder" :name="name" :id="name" v-bind:value="value" v-on:input="update($event.target.value)"/>
          <input v-if="type==='numeric'" class="input" @blur="$emit('blur')" :disabled="disabled" type="text" inputmode="numeric" pattern="[0-9]*" :placeholder="placeholder" :name="name" :id="name" v-bind:value="value" v-on:input="update($event.target.value)"/>
          <SwitchField v-if="type==='switch'" :name="name" :id="name" :possibleValues="possibleValues" v-bind:value="value" v-on:input="update($event)" :checkbox="checkbox" :disabled="disabled"></SwitchField>
          <CalendarField v-if="type==='calendar'" :name="name" :id="name" v-bind:value="value" v-on:input="update($event)" @blur="validate()" :defaultDate="defaultDate" :defaultPanel="defaultPanelDate" :rules="calendarRules"></CalendarField>
          <SelectField v-if="type==='select'" :name="name" :id="name" :options="possibleValues" v-bind:value="value" v-on:input="update($event)" @blur="validate()"></SelectField>
          <PhoneField v-if="type==='phone'" :name="name" :id="name" v-bind:value="value" v-on:input="update($event)" @blur="validate()" :placeholder="placeholder"></PhoneField>
          <IndexField v-if="type==='index'" :name="name" :id="name" v-bind:value="value" v-on:input="update($event)" @blur="validate()"></IndexField>
          <FileField v-if="type==='file'" :name="name" :id="name" :loading="loading" v-bind:value="value" v-on:input="update($event)" :disabled="disabled"></FileField>
          <LocalityField v-if="type==='locality'" @changecountry="$emit('changecountry', $event)" :editableCountry="editableCountry" :country="country" :name="name" :id="name" v-bind:value="value" v-on:input="update($event)" @blur="validate()"></LocalityField>
          <StreetField v-if="type==='street'" :manualInput="manualInput" :country="country" :name="name" :id="name" v-bind:value="value" v-on:input="update($event)" @blur="validate()" :locality="locality"></StreetField>
          <div v-if="type==='checkbox'" class="checkbox inline left">
            <div class="pointer check-button" :class="{active : value}" @click="not(value)"></div>
            <div class="pointer check-label" @click="not(value)"><span v-html="checkLabel"></span><span class="required" v-if="required">*</span></div>
            <input type="hidden" :value="value" />
            <span v-if="!label && help" class="help" @click="showHelp = true">?</span>
          </div>
          <span v-if="(type==='numeric' || type==='text') && unit !== null" class="unit">{{ unit }}</span>
        </div>

        <!-- Validation & Unit -->
        <div class="error-block" v-if="!silentError">{{ errors[0] }}</div>
        <div class="warning-block" v-if="!silentError">{{ warning }}</div>
        <Help v-if="help && showHelp" class="help" :help="help" @close="showHelp = false"></Help>
    </div>
    <!-- IS-4763: re-enable if needed -->
    <!-- <div v-if="type==='street' && allowManual && (!country || country === 'BE')" class="form-field street-checkbox" :class="{ 'disabled': disabled, 'loading': loading }">
      <div class="status checkbox" :class="[{unit: unit !== null}, type, {TA:isTestAchat}]">
        <div class="checkbox inline left">
          <div class="pointer check-button" :class="{active: manualInput}" @click="manualInput = !manualInput"></div>
          <div class="pointer check-label" @click="manualInput = !manualInput">{{ $t('Contract.DeliveryAddress.unknown')}}</div>
          <input type="hidden" :value="manualInput" />
        </div>
      </div>
    </div> -->
  </ValidationProvider>
</template>

<script>
import SwitchField from "@/components/Form/BecomeFields/SwitchField.vue";
import CalendarField from "@/components/Form/BecomeFields/CalendarField.vue";
import SelectField from "@/components/Form/BecomeFields/SelectField.vue";
import PhoneField from "@/components/Form/BecomeFields/PhoneField.vue";
import IndexField from "@/components/Form/BecomeFields/IndexField.vue";
import FileField from "@/components/Form/BecomeFields/FileField.vue";
import LocalityField from "@/components/Form/BecomeFields/LocalityField.vue";
import StreetField from "@/components/Form/BecomeFields/StreetField.vue";
import Help from "@/components/Help.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showHelp: false,
      manualInput: false,
    }
  },
  props: {
    name: {
      // Form field name - default random
      type: String,
      required: true
    },
    type: {
      validator: function (value) {
        // Value must be one of this type
        return (
          ["text", "calendar", "numeric", "switch", "checkbox", "select", "phone", "email", "index", "file", "locality", "password", "street"].indexOf(
            value
          ) !== -1
        );
      },
      required: true,
    },
    label: {
      // Label of the field
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: [String, Number],
    },
    required: {
      type: [Boolean, Number],
      required: false,
    },
    possibleValues: {
      type: Array,
    },
    unit: {
      type: String,
      required: false,
      default: null
    },
    checkLabel: {
      type: String,
      required: false
    },
    rules: {
      type: String,
      required: false
    },
    silentError: {
      type: Boolean,
      required: false,
      default: false
    },
    warning: {
      type: String,
      required: false,
      default: null
    },
    defaultDate: {
      type: Date,
      required: false
    },
    defaultPanelDate: {
      type: String,
      required: false,
      default: "year"
    },
    calendarRules: {
      type: Function,
      required: false,
      default: () => { return false }
    },
    country: {
      type: String,
      required: false,
      default: 'BE'
    },
    editableCountry: {
      type: Boolean,
      required: false,
      default: false
    },
    locality: {
      type: Object,
      required: false,
    },
    checkbox: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    help: {
      type: Object,
      required: false,
    },
    allowManual: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: [Number, String, Array, Date, Boolean, Object, FileList],
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    validationRules() {
      let rules = this.rules;
      if(this.required) {
        let required = this.type === 'checkbox' ? 'true' : 'required';
        rules = !rules ? required : `${required}|${rules}`;
      }

      return rules;
    }
  },
  methods: {
    async validate() {
      if(this.$refs.provider !== undefined)
        await this.$refs.provider.validate();
    },
    async not(value) {
      if(!this.disabled) {
        if(value) value = 0;
        else value = 1;

        await this.update(value);
        this.validate();
      }
    },
    update(value) {
      this.$emit("input", value);
    }
  },
  watch: {
    type: {
      handler(value) {
        if (["switch", "select"].indexOf(value) !== -1 && typeof this.possibleValues === "undefined") {
          console.error("property 'possibleValues' is required.");
        }

        if (["checkbox"].indexOf(value) !== -1 && typeof this.checkLabel === "undefined") {
          console.error("property 'checkLabel' is required.");
        }

        if (["street"].indexOf(value) !== -1 && typeof this.locality === "undefined") {
          console.error("property 'locality' is required.");
        }
      },
      immediate: true,
    },
    warning: {
      handler(value) {
        return value;
      },
      immediate: true
    }
  },
  components: {
    SwitchField,
    CalendarField,
    SelectField,
    PhoneField,
    IndexField,
    FileField,
    LocalityField,
    StreetField,
    Help
  }
};
</script>

<style lang="scss" scoped>
.form-field {
  margin: 0 15px 15px 15px;
  text-align: left;
  position: relative;

  .label {
    .title {
      position: relative;
      display: block;
      margin: 0 0 5px 0;
    }

    .help {
      cursor: pointer;
      margin-left: 5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: .7rem;
      height: 18px;
      width: 18px;
      background: $yellow;
      border-radius: 50%;
    }
  }

  .TA {
    .help {
      background: $pink;
      color: $white;
    }

    .required {
      color: $pink;
    }
  }

  .status {
    position: relative;

    /deep/ .input {
      font-family: "ObjectSans", Helvetica, Arial, sans-serif;
      font-size: 1rem;
      width: calc(100% - 24px);
      padding: 5px 10px;
      border-radius: 4px;
      border: 2px solid $yellow;
      margin: 0;

      &::placeholder {
        color: $middleGrey;
      }

      &:focus {
        outline: none !important;
        border: 2px solid $yellow;
        -webkit-appearance: none;
        -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
      }

      &:invalid {
        box-shadow: none!important;;
      }

    }

    .pointer {
      cursor: pointer;
    }

    &::after {
      content: '';
      position: absolute;
      display: none;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      top: calc(50% - 8px);
      right: 10px;
      color: $white;
      font-size: 0.7rem;
      background: $yellow;
      border-radius: 50%;
      height: 16px;
      width: 16px;
    }

    &.unit {
      display: flex;
      .input {
        border-radius: 4px 0 0 4px;
        width: calc(100% - 24px - 44px);
        border-right: 0;
        flex: 1;
      }

      &::after { right: 50px; }

      span.unit {
        // width: 36px;
        display: inline-block;
        font-size: 0.8rem;
        border-radius: 0 4px 4px 0;
        border: 2px solid $yellow;
        border-left: 0;
        padding: 7px 6px;
        // margin: -4px;
        text-align: center;
        background: $clearYellow;
      }
    }

    &.locality::after { right: 30px; }
    &.calendar::after { right: 40px; }
    &.index::after,
    &.switch::after,
    &.checkbox::after,
    &.select::after {
      display: none!important
    }

    &.checkbox {
      .check-button {
        width: 16px;
        height: 16px;
        border: 2px solid $grey;
        border-radius: 4px;

        &.active {
          border: 2px solid $yellow;
          background: $yellow;
          position: relative;

          &::before {
            content: '';
            background:url("~@/assets/icons/icon-check.svg") no-repeat center/14px 14px $yellow;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }

          & + .check-label {
            font-weight: 500;
          }
        }
      }

      .check-label {
        display: block;
        font-size: 0.8rem;
        margin: 0 0 0 10px;
        max-width: calc(100% - 40px);
      }

      .help {
        cursor: pointer;
        margin-left: 5px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: .9rem;
        height: 18px;
        width: 18px;
        background: $yellow;
        border-radius: 50%;
      }
    }

    &.TA {
      /deep/ .input {
        border: 2px solid $pink!important;

        &:focus {
          border: 2px solid $pink!important;
        }
      }

      &.unit {
        span.unit {
          border: 2px solid $pink!important;
          background: $pink!important;
          color: $white!important;
        }
      }

      &.checkbox {
        .check-button {
          &.active {
            border: 2px solid $black!important;
            background: $black!important;

            &::before {
              content: '';
              background:url("~@/assets/icons/icon-check-white.svg") no-repeat center/14px 14px $black;
            }
          }
        }

        .check-label {
          /deep/ a {
            text-decoration: underline $pink!important;
            color: $pink!important;
          }
        }
      }

      .help {
        background: $pink;
        color: $white;
      }
    }
  }

  &.error {
    .status {
      &::after {
        content: '!';
        display: flex;
        background: $red;
      }

      /deep/ .input {
        border: 2px solid $red!important;
      }

      &.unit {
        .input {
          border-right: 0!important;
        }

        span.unit {
          background: $clearRed;
          border: 2px solid $red;
          border-left: 0;
        }
      }

      /deep/ .mx-icon-calendar {
        background: $clearRed;
        border: 2px solid $red;
        border-left: 0;
      }

      /deep/ .vs__dropdown-toggle {
        border: 2px solid $red!important;
      }

      &.phone {
        /deep/ .vs__dropdown-toggle {
          border: 2px solid $red!important;
          border-right: 0!important;
          background: $clearRed!important;
        }

        /deep/ .input {
          border-left: 0!important;
        }
      }

      &.switch .switch {
        // border: 2px solid $red;

        /deep/ .item {
          &::before {
            border: 2px solid $red;
          }
        }
      }

      &.index /deep/.index .input { border: 0!important;}
    }

    .error-block {
      display: flex;
      align-items: center;
    }
  }

  &.warning {
    font-size: 1rem!important;
    .status {
      &::after {
        content: '!';
        display: flex;
        background: $yellow;
      }
    }

    .warning-block {
      display: flex;
      align-items: center;
    }
  }

  .error-block {
    display: none;
    font-size: 0.8rem;
    margin-top: 5px;
    color: $red;
  }

  .warning-block {
    display: none;
    font-size: 0.8rem;
    margin-top: 5px;
    color: $red;
  }

  &.valid {
    .status {
      &::after {
        content: '';
        display: flex;
        background:url("~@/assets/icons/icon-form-valid.svg") no-repeat center/10px 10px  #0e923f;
      }
    }
  }

  &.loading {

  }

  &.disabled {

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form/BecomeField.vue